import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home";
import CreateActivity from "../views/CreateActivity";
import ReadActivity from "../views/ReadActivity";
import MyActivities from "../views/MyActivities";
import Profil from "../views/Profil";
import Favoris from "../views/Favoris";
import SuccessfullRegistration from "../views/SuccessfullRegistration";
import MyDrafts from "../views/MyDrafts";
import Login from "@/views/Login";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { layout: "no-navbar" }
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/about-us",
    name: "About Us",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutUs.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/cookie-policy",
    name: "Cookie Policy",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CookiePolicy.vue"),
    meta: { layout: "no-navbar" }
  },
  {
    path: "/contact",
    name: "Contact",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Contact.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/my-activities",
    name: "MyActivities",
    component: MyActivities,
    meta: { requiresAuth: true }
  },
  {
    path: "/create/activity",
    name: "CreateActivity",
    component: CreateActivity,
    meta: { requiresAuth: true }
  },
  {
    path: "/consult/activity/:id",
    name: "ReadActivity",
    component: ReadActivity,
    meta: { requiresAuth: true }
  },
  {
    path: "/profil",
    name: "Profil",
    component: Profil,
    meta: { requiresAuth: true }
  },
  {
    path: "/favorites",
    name: "Favoris",
    component: Favoris,
    meta: { requiresAuth: true }
  },
  {
    path: "/drafts",
    name: "Brouillon",
    component: MyDrafts,
    meta: { requiresAuth: true }
  },
  {
    path: "/successfull-registration",
    name: "SuccessfullRegistration",
    component: SuccessfullRegistration,
    meta: { requiresAuth: false, layout: "no-navbar" }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
